import axios from "axios";

const moduleCatagoryMaster = {
  namespaced: true,
  state: {
    catagoryList: [],
    createCatagoryItem: null,
  },
  mutations: {
    setCatagoryList(state, data) {
      state.catagoryList = data;
    },
  },
  actions: {
    async fetchCatagoryList({ commit }, { clinicUrl, branchUrl }) {
      try {
        const res = await axios.get(
          `/api/master/mProductCate/${clinicUrl}/${branchUrl}`
        );
        const items = res.data.data.map(i => ({
          catagoryId: i.id,
          catagoryCode: i.code,
          catagoryNameTh: i.description,
          catagoryNameEn: i.description2,
          catagoryStatus: i.status,
          creationDt: i.creationDt,
        }));
        commit("setCatagoryList", items);
        return items;
      } catch (err) {
        console.error("fetchCatagoryList failed", err);
        throw err;
      }
    },
    createCatagoryItem({ commit, getters }, payload) {
      return axios
        .post(
          `/api/master/mProductCate/${payload.clinicUrl}/${payload.branchUrl}`,
          payload.adjustCatagoryItem,
          {
            skipGlobalErrorHandler: true,
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },

    updateCatagoryItem({ commit, getters }, payload) {
      return axios
        .put(
          `/api/master/mProductCate/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`,
          payload.adjustCatagoryItem,
          {
            skipGlobalErrorHandler: true,
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },

    deleteCatagoryItem({ commit, getters }, payload) {
      return axios
        .delete(
          `/api/master/mProductCate/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`,
          {
            skipGlobalErrorHandler: true,
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },
  },
  getters: {
    getCatagoryList: state => {
      return state.catagoryList;
    },
  },
};

export default moduleCatagoryMaster;
